exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".viewPageTem .base-modal-body{overflow:auto;padding:20px 0}.viewPageTem .base-modal-body .printContent{padding:20px}.viewPageTem .viewTemplateArea{padding:0 20px}.viewPageTem .viewTemplateArea .descrip{padding:8px 0;cursor:pointer}.viewPageTem .viewTemplateArea .descrip .arrow{display:inline-block;margin-right:4px}.viewPageTem .viewTemplateArea .descrip .arrow.fold{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}", ""]);

// exports
